export default __webpack_public_path__ + "static/media/wegovy-pencap-remove.b7ad097e.mp4";